import React, { useState } from 'react';
import { Button } from '../../../nq-component';
import SelectSearch from '../../../components/SelectSearch';

function CustomFilter({ onSubmit, onCancel }) {
  const [status, setStatus] = useState({ label: '', value: '' });
  const [date, setDate] = useState('');

  function handleSubmit() {
    const where = {};
    const or = [];

    if (or.length > 0) {
      where['$or'] = or;
    }

    if (status?.value) {
      where['status'] = status.value;
    }

    if (date) {
      where['created'] = {
        $gte: new Date(date).toISOString().split('T')[0] + 'T00:00:00.000Z',
        $lte: new Date(date).toISOString().split('T')[0] + 'T23:59:59.999Z',
      };
    }

    onSubmit(where);
  }

  function clearFilters() {
    setStatus({ label: '', value: '' });
    setDate('');
    handleSubmit();
  }

  const statusOptions = [
    { label: 'Draft', value: 'Draft', colorClass: 'btn-outline-dark' },
    { label: 'Pending (Warm Lead)', value: 'Pending (Warm Lead)', colorClass: 'btn-outline-warning' },
    { label: 'Pending (Cold Lead)', value: 'Pending (Cold Lead)', colorClass: 'btn-outline-success' },
    { label: 'Cancelled', value: 'Cancelled', colorClass: 'btn-outline-danger' },
    { label: 'Closed Deal', value: 'Closed Deal', colorClass: 'btn-outline-primary' },
  ];

  return (
    <div>
      <div className='mb-3'>
        <label className='form-label fw-bolder'>Date</label>
        <input
          type='date'
          className='form-control'
          value={date}
          onChange={(e) => setDate(e.target.value)}
        />
      </div>

      <div className='mb-3'>
        <label className='form-label fw-bolder'>Status</label>
        <SelectSearch
          value={status}
          onChange={(selected) => setStatus(selected)}
          options={statusOptions}
          placeholder="Select status"
        />
      </div>

      <div className='d-flex justify-content-end align-items-end gap-2 mt-4'>
        <Button className='btn btn-light fw-bolder w-100' onClick={clearFilters}>
          Clear
        </Button>
        <Button className='btn btn-primary fw-bolder text-black w-100' onClick={handleSubmit}>
          Apply 
        </Button>
      </div>
    </div>
  );
}

export default CustomFilter;
